import { headingMd } from '@insify/design-system/typography';
import clsx from 'clsx';
import { graphql } from 'gatsby';
import { Section } from '~components/Section';
import { Heading } from '~components/Heading';
import { Slider } from '~components/Slider';
import { ContentfulComponentImageTextCard } from '~components/ContentfulComponentImageTextCard';
import * as sharedStyles from '~styles/shared.module.css';
import * as styles from './ContentfulComponentCardGroup.module.css';

import type { ContentBlock } from '~components/types';
import type { ContentfulComponentImageTextCardContent } from '~components/ContentfulComponentImageTextCard';
import type { Theme } from '~models/contentful';

export type ContentfulComponentCardGroupContent = {
  __typename: 'ContentfulComponentCardGroup';
  contentful_id: string;
  cardGroupTitle?: string;
  cards: ContentfulComponentImageTextCardContent[];
  theme?: Theme;
};

type ContentfulComponentCardGroupProps = {
  content: ContentfulComponentCardGroupContent;
};

export const ContentfulComponentCardGroup: ContentBlock<ContentfulComponentCardGroupProps> = ({
  content,
  ...sectionProps
}) => {
  const { cardGroupTitle, cards } = content;

  return (
    <Section {...sectionProps}>
      {cardGroupTitle && (
        <Heading className={clsx(headingMd, sharedStyles.contentWrapper, styles.title)}>{cardGroupTitle}</Heading>
      )}
      <Slider slideWidth={308} gapWidth={16}>
        {cards.map((card, index) => (
          <ContentfulComponentImageTextCard key={index} content={card} />
        ))}
      </Slider>
    </Section>
  );
};

export const query = graphql`
  fragment ComponentCardGroup on ContentfulComponentCardGroup {
    __typename
    cardGroupTitle: title
    cards {
      ...ComponentImageTextCard
    }
    theme
  }
`;
